export default __webpack_public_path__ + "static/media/cowrywise.cc1949d4.png";